import { render, staticRenderFns } from "./StateAwardCard.vue?vue&type=template&id=a9160e54&scoped=true"
import script from "./StateAwardCard.vue?vue&type=script&lang=js"
export * from "./StateAwardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9160e54",
  null
  
)

export default component.exports